import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import './index.scss';
import Footer from '../../containers/footer';
import { getUserData, getUserID } from '../../utils/services';
import HelpCard from '../../components/help-card';
import { ROUTES as _routes } from '../../constants/app-constants';
import AccountSubSecTitle from '../../components/accout-subsec-title';
import { requestAccountDelete } from '../../burger-king-lib/redux/login/actions';
import withMobileHeaderFooterAdding from '../../components/mobile-layout';
import MobileFooter from '../../containers/mob-footer';

const HelpSupportPage = props => {
  const history = useHistory();
  const deleteAccountresponse = useSelector(
    state => state?.login?.deteleUserResponse
  );
  const dispatch = useDispatch();
  const [userData, setUserData] = useState();
  const { isSeparatePage, theme } = props;
  const {
    mobileFooterClickHandler,
    activeKey,
    isMobileScreen,
    isAccountScreen
  } = props;

  const helpList = [
    {
      id: 1,
      title: 'How do I contact Customer Care?',
      description:
        'You can contact us by writing to <a href="mailto:customercare@burgerking.in">customercare@burgerking.in</a>'
    },
    {
      id: 2,
      title: 'Where can I place the Order?',
      description: `You can place Order at Burger King restaurants in dine at the counter, Self-Ordering 
      Kiosk (SOK), Table Ordering through QR code on BK Application (App) and in Delivery  online 
      order through / Burger King Website, BK App  and  food aggregator platforms (<strong>“Sales 
      Channels”</strong>). `
    },
    {
      id: 3,
      title: 'How can I place an Order?',
      description: `The Order can be placed on various Sales Channels, the customer at his 
      will/consent can register using Mobile Number on BK App/ Burger King Website or Self 
      Ordering Kiosk. The Mobile Number enables us to identify you as a unique guest and helps us 
      avoid the creation of multiple accounts. On login in / registering using the mobile number the 
      customer can avail the  benefits of the loyalty program. `
    },
    {
      id: 4,
      title: 'I did not get OTP code on my mobile?',
      description:
        'Sometimes there could be a delay in receiving the OTP due to network congestion. If you still haven’t received it within a few minutes, please email us at <a href="mailto:customercare@burgerking.in">customercare@burgerking.in</a> and we will help you out.'
    },
    {
      id: 5,
      title: 'What are your operating hours?',
      description: ` Operating hours vary from restaurant to restaurant , and you can check the operating 
      time of your neighbourhood restaurant or  by logging in to the BK App, Burger King website.`
    },
    {
      id: 6,
      title: 'Is there a minimum order value?',
      description: `No, we don't have a minimum order value. However, we have various contests, 
      coupons and offers with terms & conditions in dine in, delivery. `
    },
    {
      id: 7,
      title: 'Do you charge for delivery?',
      description: `Yes, we charge a Delivery fee on BK App to cover the delivery services for delivery 
      orders.`
    },
    {
      id: 8,
      title: 'How much time do you take to delivery?',
      description: `We strive to deliver your Orders soon as possible within the time period 
      communicated to you through the BK App, Burger King website , however, it should reach to 
      you within a maximum of 45 minutes (except Burger King – 15 minutes deliveries) While efforts 
      are made to display an estimated time of arrival (ETA) for every Order, the delivery time may 
      vary due to factors such as third-party delivery service availability, demand, traffic, weather 
      conditions, force majeure events, and other unforeseen circumstances.`
    },
    {
      id: 9,
      title: 'How can I add special instructions to my order?',
      description: `You can tell us your preference in dine in at the counter, on SOK , BK App, Burger King 
      website under the ‘Special Instructions’ section available at Order confirmation.`
    },
    {
      id: 10,
      title: 'Can I redeem multiple coupons in a single order?',
      description: 'Sorry, you cannot club multiple coupons in a single order.'
    },
    {
      id: 11,
      title: 'How do I earn crowns on the BK App?',
      description: `You can earn crowns on every order you place via the registered mobile number 
      through  BK App. Crowns will be credited to the account within 48 hrs.`
    },
    {
      id: 12,
      title: 'What can I do with the crowns that I earned?',
      description: `Crowns can be redeemed only against Burger King exciting deals (Kings deals- 
      Crowns Rewards section) on the BK App.`
    },
    {
      id: 13,
      title: 'Do earned crowns have an expiry?',
      description:
        'Crowns earned before August 1st, 2021 are valid for 365 days from the date of earning them.',
      subDescription:
        'Crowns earned after August 1st, 2021 are valid for 180 days from the date of earning them.'
    },
    {
      id: 14,
      title: 'Can I cancel my order ?',
      description:
        'You can cancel your Order only within one-minute (i.e 60 seconds) of the order being placed on app/website.',
      subDescription:
        'For Cancellation and Refund refer to Terms & Conditions and Refund section (Click and review). You cannot cancel the Order once placed on SOK in dine in at the restaurants.'
    },
    {
      id: 15,
      title: `Can the ingredients (vegetables like tomato, lettuce) fillings vary/absent in my 
      Burger/Products? 
      `,
      description: `Yes, at times due to unpredictable seasonal conditions and depending on the quality & 
      supply of crops/vegetables, we may temporarily discontinue certain ingredients ( like tomato, 
      lettuce etc) in your Burger, & other Products. `
    },
    {
      id: 16,
      title: 'What are the charges applicable on dine-in/takeaway?',
      description: 'We charge applicable taxes on dine-in/takeaway.'
    },
    {
      id: 17,
      title: 'Do you deliver products? And what are the charges applicable?',
      description: ` Yes, we do provide delivery of our products through food aggregators and BK App. 
      On BK App/ Website we charge applicable taxes and Restaurant Handling Charges. Please 
      note that Restaurant Handling Charges are charges for providing additional services and costs 
      incurred by the Company for offering the food products, which includes, but is not limited to 
      platform infrastructure setup, recurring operating/labor cost and capital cost of infrastructure.`
    },
    {
      id: 18,
      title: 'Do you charge service tax on order(s)?',
      description:
        'No we do not charge service tax on any orders.'
    },
    {
      id: 19,
      title: 'I am facing issues with BK App/Site?',
      description: 'If this happens, we would recommend: Restart your device as a first option. If this does not work, you could uninstall the App and again install the same. Lastly, contact customer services for help at <a href="mailto:customercare@burgerking.in">customercare@burgerking.in</a>'
    },
    {
      id: 20,
      title:
        'The amount was debited from my account but the transaction failed?',
      description: `You need not worry. Your amount will be refunded back to your source account. 
      Refund takes up to 5-7 business days from the date of refund to reflect on your bank account. 
      Please refer to the Terms & Conditions`
    },
    {
      id: 21,
      title: 'Do you charge for carry bags?',
      description:
        'Carry bags with handles are provided on a chargeable basis. Carry Bags are available on request at all Burger King restaurants and can also be selected from BK App while placing an order at the check-out page.'
    },
    {
      id: 22,
      title: 'Do we have no onion and no garlic(NONG) restaurants in India?',
      description: 'Yes, we have selected NONG restaurants in India.'
    },
    {
      id: 23,
      title: 'Do we have in-store table ordering through QR code?',
      description:
        'Yes, we have in-store table ordering through QR code in the selected restaurants. Please refer to the term and conditions for further information.'
    },
    {
      id: 24,
      title: 'How can I request for account deletion?',
      description:
        'You can request for account deletion by clicking the below request button/text.'
    },
    {
      id: 25,
      title: 'Can we use SOK in restaurants to order?',
      description: `Yes, SOK in restaurants  is available  to Order in multiple languages. Please refer to the 
      Terms & Conditions for further information.`
    }
  ];

  const goBackOnClick = () => {
    history.goBack();
  };

  const onTermsClick = () => {
    const { isSeparatePage, history } = props;
    if (isSeparatePage) {
      history.push(_routes.TERMS);
    } else {
      history.push(_routes.TERMS_AND_CONDITIONS);
    }
  };

  const onClickAccountDelete = () => {
    const payload = {
      user_id: getUserID()
    };
    dispatch(requestAccountDelete(payload));
  };

  useEffect(() => {
    const userData = getUserData();
    setUserData(userData);
  }, []);

  return (
    <>
      <div className="u_mobile-header">
        {isMobileScreen && (
          <AccountSubSecTitle
            title="FAQ's & Support"
            goBackOnClick={goBackOnClick}
            theme={theme}
          />
        )}
      </div>
      <div
        className={`help-pg_wrapper ${isSeparatePage ? 'help-pg_full' : ''}`}
      >
        {!isSeparatePage && (
          <AccountSubSecTitle
            title="FAQ's & Support"
            goBackOnClick={goBackOnClick}
            theme={theme}
          />
        )}
        <div className="help-pg__card">
          {/* {isSeparatePage && <AccountSubSecTitle title="FAQ's & Support" />} */}
          <p className="help-pg__title">How can we help?</p>
          {helpList && helpList.length
            ? helpList.map(data => {
                return (
                  <HelpCard
                    data={data}
                    theme={theme}
                    userData={userData}
                    onClickAccountDelete={onClickAccountDelete}
                    deleteAccountresponse={deleteAccountresponse}
                  />
                );
              })
            : ''}
        </div>
        {isSeparatePage && <Footer />}
      </div>
      <div className="u_mobile-footer">
        {isMobileScreen && !isAccountScreen && (
          <MobileFooter
            activeKey={activeKey}
            mobileFooterClick={mobileFooterClickHandler}
            theme={theme}
          />
        )}
      </div>
    </>
  );
};

export default withMobileHeaderFooterAdding(HelpSupportPage);
